module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"availableTitle":"{title} is available","pageCreated":"Your page has been created!","takenTitle":"{title} is already taken"},"fr":{"availableTitle":"{title} est disponible","pageCreated":"Votre page a été créée","takenTitle":"{title} est déjà pris"}}')
  delete Component.options._Ctor
}
